"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SectionBoundary = exports.CARD_NOT_SHOWN_REASON = void 0;
var _react = _interopRequireWildcard(require("react"));
var _CardsNotShownContext = require("../context/CardsNotShownContext");
var _sentryReporter = require("../utils/sentry-reporter");
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var CARD_NOT_SHOWN_REASON = exports.CARD_NOT_SHOWN_REASON = "Could not be shown, not applied";
var ACTION_ID_SEPARATOR = "\0";
function resetKeysChanged(previousKeys, nextKeys) {
  if (previousKeys === undefined || nextKeys === undefined) return previousKeys !== nextKeys;
  if (previousKeys.length !== nextKeys.length) return true;
  return previousKeys.some(function (previousKey, index) {
    return !Object.is(previousKey, nextKeys[index]);
  });
}
var CardsNotShownWhileFallbackShows = function CardsNotShownWhileFallbackShows(_ref) {
  var section = _ref.section,
    actionIds = _ref.actionIds;
  var _useCardsNotShown = (0, _CardsNotShownContext.useCardsNotShown)("boundary:".concat(section)),
    markNotShown = _useCardsNotShown.markNotShown;
  var actionIdsKey = actionIds.join(ACTION_ID_SEPARATOR);
  (0, _react.useEffect)(function () {
    if (actionIdsKey === "") return undefined;
    var idsNotShown = actionIdsKey.split(ACTION_ID_SEPARATOR);
    markNotShown(idsNotShown, CARD_NOT_SHOWN_REASON);
    return function () {
      return markNotShown(idsNotShown, null);
    };
  }, [actionIdsKey, markNotShown]);
  return null;
};
var SectionBoundary = exports.SectionBoundary = /*#__PURE__*/function (_Component) {
  function SectionBoundary() {
    var _this;
    _classCallCheck(this, SectionBoundary);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, SectionBoundary, [].concat(args));
    _defineProperty(_this, "state", {
      failed: false
    });
    _defineProperty(_this, "reset", function () {
      _this.setState({
        failed: false
      });
    });
    return _this;
  }
  _inherits(SectionBoundary, _Component);
  return _createClass(SectionBoundary, [{
    key: "componentDidCatch",
    value: function componentDidCatch(error) {
      (0, _sentryReporter.reportError)(error, {
        extra: {
          component: "SectionBoundary",
          section: this.props.section
        }
      });
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      if (this.state.failed && resetKeysChanged(previousProps.resetKeys, this.props.resetKeys)) this.reset();
    }
  }, {
    key: "render",
    value: function render() {
      if (!this.state.failed) return this.props.children;
      var _this$props = this.props,
        section = _this$props.section,
        fallback = _this$props.fallback,
        cardActionIds = _this$props.cardActionIds;
      return /*#__PURE__*/(0, _jsxRuntime.jsxs)(_jsxRuntime.Fragment, {
        children: [typeof fallback === "function" ? fallback(this.reset) : fallback, cardActionIds === undefined || cardActionIds.length === 0 ? null : /*#__PURE__*/(0, _jsxRuntime.jsx)(CardsNotShownWhileFallbackShows, {
          section: section,
          actionIds: cardActionIds
        })]
      });
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError() {
      return {
        failed: true
      };
    }
  }]);
}(_react.Component);